import React from "react";
import { useLang } from "@/context/LangContext";
import { Grape } from "lucide-react";

const LangSwitcher = () => {
  const { lang, setLang } = useLang();
  return (
    <div className="inline-flex items-center gap-1 rounded-full border border-olive/20 bg-white/70 backdrop-blur-md px-1 py-1 text-[11px] tracking-[0.2em] uppercase">
      <button
        data-testid="lang-es-btn"
        onClick={() => setLang("es")}
        className={`px-3 py-1.5 rounded-full transition-all duration-300 ${lang === "es" ? "bg-wine text-cream shadow-sm" : "text-olive hover:text-wine"}`}
      >
        ES
      </button>
      <button
        data-testid="lang-ro-btn"
        onClick={() => setLang("ro")}
        className={`px-3 py-1.5 rounded-full transition-all duration-300 ${lang === "ro" ? "bg-wine text-cream shadow-sm" : "text-olive hover:text-wine"}`}
      >
        RO
      </button>
    </div>
  );
};

const Header = () => {
  const { t } = useLang();
  return (
    <header
      data-testid="site-header"
      className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-cream/70 border-b border-olive/10"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
        <a href="#hero" className="flex items-center gap-2 group" data-testid="brand-link">
          <Grape className="w-4 h-4 text-wine transition-transform duration-500 group-hover:rotate-12" strokeWidth={1.5} />
          <span className="font-serif text-base tracking-wide text-wine">M & A</span>
        </a>
        <nav className="hidden md:flex items-center gap-8 text-[11px] tracking-[0.25em] uppercase text-olive">
          <a href="#details" className="hover:text-wine transition-colors duration-300" data-testid="nav-details">{t.nav.details}</a>
          <a href="#rsvp" className="hover:text-wine transition-colors duration-300" data-testid="nav-rsvp">{t.nav.rsvp}</a>
        </nav>
        <LangSwitcher />
      </div>
    </header>
  );
};

export default Header;
